
import React from 'react'

export default function Input ({ required, myref, name, placeholder, defaultValue, type, autocomplete, className }) {
  return (
      <input required={required} autoComplete={autocomplete} defaultValue={defaultValue} ref={myref} className={`cursor-pointer m-2 p-2 rounded-lg border-gray-300 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:border-transparent border-2 ${className}`} type={type || 'text'} name={name} placeholder={placeholder} />

  )
}
